import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePage from "./Pages/Desktop/HomePage/HomePage";
import MedicalDetails from "./Pages/Desktop/MedicalDetails/MedicalDetails";
import NomineeDetails from "./Pages/Desktop/NomineeDetails/NomineeDetails";
import ProposarDetails from "./Pages/Desktop/ProposarDetails/ProposarDetails";
import QuotePage from "./Pages/Desktop/QuotePage/QuotePage";
import TravellerDetails from "./Pages/Desktop/TravellerDetails/TravellerDetails";
import { PATH } from "./shared/Path";
import TravelInformation from "./Pages/Desktop/TravelInformation/TravelInformation";
import PreviewPage from "./Pages/Desktop/PreviewPage/PreviewPage";
import ThankYouPage from "./Pages/Desktop/ThankYouPage/ThankYouPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={PATH.HOME} element={<HomePage />} />
        <Route path={PATH.MEDICAL_DETAILS} element={<MedicalDetails />} />
        <Route path={PATH.NOMINEE_DETAILS} element={<NomineeDetails />} />
        <Route path={PATH.PROPOSAL_PAGE} element={<ProposarDetails />} />
        <Route path={PATH.QUOTE_PAGE} element={<QuotePage />} />
        <Route path={PATH.TRAVELLER_DETAILS} element={<TravellerDetails />} />
        <Route
          path={PATH.TRAVELLER_INFORMATION}
          element={<TravelInformation />}
        />
        <Route path={PATH.PREVIEW_PAGE} element={<PreviewPage />} />
        <Route path={PATH.THANK_YOU} element={<ThankYouPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
